<template>
  <b-button variant="light" @click="onclick()">
    {{ title }} <b-badge variant="dark" title="Antal">{{ cnt }}</b-badge>
    <b-badge
      v-for="(c, i) in button.cols"
      :key="i"
      variant="primary"
      :title="getTitle(c)"
      >{{ c.res }}</b-badge
    >
  </b-button>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "queryviewbutton",
  props: { button: Object, refresher: Number },
  data() {
    return {
      title: "",
      cnt: null,
      MyModal: false,
    };
  },
  created() {
    setTimeout(this.Refresh, 50);
    //this.Refresh();
  },
  watch: {
    button: function () {
      this.Refresh();
    },
    refresher: function () {
      this.Refresh();
    },
  },
  methods: {
    Refresh() {
      if (this.button) {
        //This is not post, but is necessary for the server side
        api
          .post("/api/apiqueryview/GetQueryViewButtonResult", this.button)
          .then((res) => {
            //console.log(res.data);
            if (res.data.errMsg) this.res = res.data.errMsg;
            else {
              this.title = res.data.name;
              this.cnt = res.data.cnt;
              var cs = res.data.cols;
              if (cs && this.button.cols) {
                //this.button.cols
                for (var i = 0; i < cs.length; i++)
                  this.button.cols[i].res = cs[i].res;
              }
            }

            this.$forceUpdate();
          });
      }
    },
    getTitle(col) {
      if (col) return `${col.op}(${col.title})`;
    },
    onclick() {
      this.$emit("click", this.button.queryid);
    },
    Update(ev) {
      //alert('Update');
      this.cnt = null;
      this.Refresh();
      ev.preventDefault();
    },
  },
};
</script>